// extracted by mini-css-extract-plugin
module.exports = {"logo":"AppLogo_logo__DZr9_","warning":"AppLogo_warning__10K9b"};